module.exports = __webpack_public_path__ + "ViasatFotball-0cb729a79acd561aa3ea227b2894ac21.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/ViasatFotball.jpg
// module id = 1149
// module chunks = 0 1